function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49 8H17c-4.411 0-8 3.589-8 8v32c0 4.411 3.589 8 8 8h8a2 2 0 0 0 0-4h-8c-2.206 0-4-1.794-4-4V16c0-2.206 1.794-4 4-4h32c2.206 0 4 1.794 4 4v32c0 2.206-1.794 4-4 4h-8a2 2 0 0 0 0 4h8c4.411 0 8-3.589 8-8V16c0-4.411-3.589-8-8-8z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.43 36.394a2 2 0 0 0-.037-2.828l-6.567-6.396c-.755-.756-1.76-1.172-2.829-1.172s-2.073.416-2.81 1.153l-6.586 6.414a2 2 0 1 0 2.792 2.865l6.624-6.414 6.585 6.414a2 2 0 0 0 2.828-.036z"
});

var SvgTop = function SvgTop(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/top.2b92588b.svg";
export { ForwardRef as ReactComponent };